<template>
  <div class="mb-32 mx-auto">
    <h2 class="py-2 font-semibold uppercase tracking-wide text-xs border-b border-blackish">
      {{ $t('profile.orders') }}
    </h2>
  <section class="mt-5 flex font-bold text-xxs md:text-xs w-full justify-between pl-2 text-center">
      <h3 class="capitalize w-1/3 md:w-1/4 text-left">
        {{ $t('orders.number') }}
      </h3>
      <h3 class="capitalize w-1/6 hidden md:block">
        {{ $t('orders.date') }}
      </h3>
      <h3 class="capitalize w-1/6">
        {{ $t('orders.amount') }}
      </h3>
      <h3 class="capitalize w-1/3 text-center md:w-1/4 ml-2 md:ml-0">
        {{ $t('orders.status') }}
      </h3>
  </section>
  <section class="mt-5">
    <ul>
      <li class="text-xs flex justify-between border-b mb-2 py-2 pl-2"
        :class="fontHairline()"
        v-for="order in orders" :key="order.id"
      >
        <div class="md:hidden w-1/3">
          <h4 class="font-bold uppercase">
            <router-link :to="{name: 'single-order', params: {order_no: order.order_no}}">
              {{ order.order_no }}
            </router-link>
          </h4>
          <h5 class="">
            {{ order.created_at }}
          </h5>
        </div>
        <h4 class="font-bold uppercase w-3/8 md:w-1/4 hidden md:block">
          <router-link :to="{name: 'single-order', params: {order_no: order.order_no}}">
            {{ order.order_no }}
          </router-link>
        </h4>
        <h5 class="w-1/6 hidden md:block text-center">
          {{ order.created_at }}
        </h5>
        <h5 class="w-1/6 text-center">
          {{ formatter.format(order.total_with_taxes / 100) }}
        </h5>
        <h5 class="w-1/3 md:w-1/4 font-bold ml-2 md:ml-0 text-center">
          {{ $t(`orders.status-${order.current_state}`) }}
        </h5>
      </li>
    </ul>
  </section>
  </div>

</template>

<script>
import { getCustomerOrders } from '@/services/OrdersService';
import { mapGetters } from 'vuex';

export default {
  metaInfo() {
    const title = this.$t('titles.orders');
    return {
      title,
      meta: [
        {
          name: 'description',
          content: 'Your orders',
        },
      ],
    };
  },

  data() {
    return {
      orders: [],
    };
  },

  computed: {
    ...mapGetters({
      customer: ['auth/customer'],
    }),
  },

  created() {
    getCustomerOrders(this.customer)
      .then(({ data }) => {
        this.orders = data;
      }).catch((error) => {
        this.checkRoutingAuthentication(error);
      });
  },
};
</script>

<style lang="scss" scoped>
.status-registered {
  @apply text-green-700;
}

.status-shipped {
  @apply text-blue-600;
}

.status-pending {
  @apply text-b2c-red-300;
}
</style>
